import { render } from "./ArticleRight.vue?vue&type=template&id=5aad1533"
import script from "./ArticleRight.vue?vue&type=script&lang=js"
export * from "./ArticleRight.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__